import { useParams, useNavigate } from 'react-router-dom';
import WeeklyProgramPage from '@/pages/website/WeeklyProgramPage';

/**
 * Admin wrapper around the regular WeeklyProgramPage. Reuses the full editor
 * UI, but swaps its data source for the admin-scoped endpoints
 * (`/api/admin/users/:id/weekly-program`) so the therapist can prepare a
 * patient's program without having to log out and log back in as them.
 */
const AdminWeeklyProgramPage = () => {
  const { userId } = useParams();
  const navigate = useNavigate();
  return (
    <WeeklyProgramPage
      targetUserId={userId}
      onBack={() => navigate('/admin')}
    />
  );
};

export default AdminWeeklyProgramPage;
